import React from 'react';
import { useI18n } from '../i18n';
import './LanguageSelector.css';

export default function LanguageSelector({ compact = false, className = '', onChange }) {
  const { language, setLanguage, t } = useI18n();

  const handleChange = async (nextLanguage) => {
    setLanguage(nextLanguage);
    if (onChange) await onChange(nextLanguage);
  };

  return (
    <div className={`language-selector ${compact ? 'compact' : ''} ${className}`} aria-label={t('language.selectorLabel')}>
      <span className="language-selector-label">{compact ? t('language.compactLabel') : t('language.selectorLabel')}</span>
      <div className="language-selector-options" role="group" aria-label={t('language.selectorLabel')}>
        <button
          type="button"
          className={language === 'es' ? 'active' : ''}
          aria-pressed={language === 'es'}
          onClick={() => handleChange('es')}
        >
          ES
        </button>
        <button
          type="button"
          className={language === 'en' ? 'active' : ''}
          aria-pressed={language === 'en'}
          onClick={() => handleChange('en')}
        >
          EN
        </button>
      </div>
    </div>
  );
}
